import { render, staticRenderFns } from "./IconAngleRight.vue?vue&type=template&id=6facf73b&"
import script from "./IconAngleRight.vue?vue&type=script&lang=ts&"
export * from "./IconAngleRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports